/* Action Types */
export const CALL_FETCH_DOCUMENTS = 'CALL_FETCH_DOCUMENTS';
export const FETCH_DOCUMENTS_FAILED = 'FETCH_DOCUMENTS_FAILED';
export const FETCH_DOCUMENTS_SUCCESS = 'FETCH_DOCUMENTS_SUCCESS';
export const TOGGLE_DOCUMENT_SELECTION = 'TOGGLE_DOCUMENT_SELECTION';
export const VIEW_DOCUMENT = 'VIEW_DOCUMENT';

/* Action Creators */
export function fetchDocuments(workflowInstanceId) {
  return { type: CALL_FETCH_DOCUMENTS, workflowInstanceId };
}

export function fetchDocumentsFailed(error) {
  return { type: FETCH_DOCUMENTS_FAILED, error };
}

export function fetchDocumentsSuccess(documents) {
  return { type: FETCH_DOCUMENTS_SUCCESS, documents };
}

export function toggleDocumentSelection(documentId) {
  return { type: TOGGLE_DOCUMENT_SELECTION, documentId };
}

export function viewDocument(documentId) {
  return { type: VIEW_DOCUMENT, documentId };
}

const INITIAL_STATE = {
  data: [],
  errors: {
    fetch: null
  },
  loading: {
    fetch: false
  }
};

/* Reducer */
export default function reducer(state = INITIAL_STATE, action) {

  const { documentId, documents, error, type } = action;

  switch (type) {
    case CALL_FETCH_DOCUMENTS:
      return {
        ...state,
        data: [],
        errors: {
          ...state.errors,
          fetch: null,
        },
        loading: {
          ...state.loading,
          fetch: true,
        },
      };
    case FETCH_DOCUMENTS_FAILED:
      return {
        ...state,
        errors: {
          ...state.errors,
          fetch: error,
        },
        loading: {
          ...state.loading,
          fetch: false,
        },
      };
    case FETCH_DOCUMENTS_SUCCESS:
      return {
        ...state,
        data:
          documents
            .map(documentObj => ({
              ...documentObj,
              selected: false
            })),
        errors: {
          ...state.errors,
          fetch: null,
        },
        loading: {
          ...state.loading,
          fetch: false,
        },
      };
    case TOGGLE_DOCUMENT_SELECTION:

      const foundDocument =
        state.data
          .find(documentObj => documentObj.idDocument === documentId);

      return {
        ...state,
        data:
          state.data
            .filter(documentObj => documentObj.idDocument !== documentId)
            .concat([{ ...foundDocument, selected: !foundDocument.selected }])
      };
    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/ducks/DocumentsDucks.js